import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const checks = ['PDF optimizado para móvil (consulta en el taller)', 'Formato imprimible en A4', 'Acceso de por vida a futuras actualizaciones'];
export function InstantAccess() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-112" data-mp="34c0tcbtxmwu7">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-113" data-mp="30ays5pgggapl">
        <SectionTag icon="📦" data-id="element-114" data-mp="30dbhwosgfpd7">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-115" data-mp="2vjh1bu85bqic">
          Todo se descarga en tu correo al instante.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-116" data-mp="2lmkrnl6igyc7">
          Material profesional descargable al instante, sin esperar envíos.
        </p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-117" data-mp="2gpc5l9i8sa5o">
          {checks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-ink" data-id="element-118" data-mp="2vrk102ahg8ds">
              <CheckIcon size={16} className="text-success" data-id="element-119" data-mp="30p2apuwbqrmu" />
              {check}
            </div>)}
        </m.div>
      </div>
    </section>;
}